import { createContext } from "react";

export const NomenclatureContext = createContext(null);
